import React, { useState, useEffect } from 'react';
import api from '../services/api';

export function useModuleAccess(moduleName) {
  const [allowed, setAllowed]   = useState(null);
  const [checking, setChecking] = useState(true);
  const [error, setError]       = useState('');
  const [password, setPassword] = useState('');
  const sessionKey = 'module_access_'+moduleName;

  useEffect(()=>{
    // Check if already unlocked this session
    if (sessionStorage.getItem(sessionKey)==='unlocked') {
      setAllowed(true); setChecking(false); return;
    }
    // Check if module has password
    api.post('/module-passwords/verify',{module_name:moduleName,password:''})
      .then(r=>{ if(r.data.allowed){ setAllowed(true); setChecking(false); } else { setAllowed(false); setChecking(false); } })
      .catch(()=>{ setAllowed(true); setChecking(false); });
  },[moduleName]);

  const verify = async () => {
    if (!password) { setError('Please enter password'); return; }
    try {
      const res = await api.post('/module-passwords/verify',{module_name:moduleName,password});
      if (res.data.allowed) {
        sessionStorage.setItem(sessionKey,'unlocked');
        setAllowed(true); setError('');
      } else {
        setError('Incorrect password!');
        setPassword('');
      }
    } catch { setError('Error verifying password'); }
  };

  const lock = () => { sessionStorage.removeItem(sessionKey); setAllowed(false); setPassword(''); };

  return { allowed, checking, password, setPassword, verify, error, lock };
}

export default function PasswordGate({ moduleName, moduleLabel, children }) {
  const { allowed, checking, password, setPassword, verify, error } = useModuleAccess(moduleName);

  if (checking) return <div className="loading-center"><div className="spinner"/></div>;

  if (!allowed) return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'60vh'}}>
      <div style={{background:'#fff',border:'1px solid var(--border)',borderRadius:16,padding:40,width:'100%',maxWidth:400,boxShadow:'0 20px 60px rgba(0,0,0,0.1)',textAlign:'center'}}>
        <div style={{width:64,height:64,background:'linear-gradient(135deg,var(--green),var(--green-dark))',borderRadius:16,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 20px',fontSize:28}}>🔒</div>
        <div style={{fontSize:20,fontWeight:700,marginBottom:6,color:'var(--text)'}}>Protected Module</div>
        <div style={{fontSize:13,color:'var(--muted)',marginBottom:24}}>Enter password to access <strong>{moduleLabel}</strong></div>
        <div style={{position:'relative',marginBottom:12}}>
          <input
            className="form-input"
            type="password"
            value={password}
            onChange={e=>setPassword(e.target.value)}
            onKeyDown={e=>e.key==='Enter'&&verify()}
            placeholder="Enter module password..."
            autoFocus
            style={{textAlign:'center',fontSize:16,letterSpacing:2,padding:'12px 16px'}}
          />
        </div>
        {error&&<div style={{color:'var(--danger)',fontSize:13,marginBottom:12,fontWeight:500}}>{error}</div>}
        <button className="btn btn-primary" onClick={verify} style={{width:'100%',padding:'12px',fontSize:14,justifyContent:'center'}}>
          Unlock Access
        </button>
      </div>
    </div>
  );

  return children;
}
